import React, { PureComponent } from 'react'
import i18n from 'live/services/i18n'
import moment from 'moment'
import DateService from 'live/services/date'
import { DefaultAnnotationFormConfigs as DEFAULT_FORM } from '../../main'
import cx from 'classnames'
import timelineService from '../../services/timeline'
import { TimelineFormRegistry } from '../../registries'

// TODO: SOLVE THIS COLOR DEPENDENCY
const formColors = [
    '#37a3ef',
    'rgb(1, 194, 146)', // success
    '#F49703', // warning
    'rgb(196, 53, 53)' // danger
]

const formDefaultColor = formColors[0]

type Props = {
    adminUser: boolean
    annotationComponent: Function
    canEdit: boolean
    dashboardId: number
    eventsHovered: Array<Record<string, any>>
    currentUser: Record<string, any>
    formComponent: Function
    onDeleteEvent: Function
    onHideTooltip: Function
    mode: string
    setTooltipRef: (ref: React.RefObject<HTMLDivElement>) => void
    setTooltipCrosshairRef: (ref: React.RefObject<HTMLSpanElement>) => void
    showForm: boolean
    showTooltip: boolean
    submitForm: Function
    tooltip: Record<string, any>
    activeDashboardFilters: Record<string, Array<string>>
}

type State = {
    currentAnnotationEvent: AnnotationEvent
    eventsHovered: Array<Record<string, any>>
    form: Record<string, any>
    showForm: boolean
    showTooltip: boolean
    submitted: boolean
    tooltip: Record<string, any>
    formsOpen: boolean
    Form: Record<string, any>
}

export default class TimelineToolTip extends PureComponent<Props, State> {
    inititalState: Record<string, any>

    constructor(props: Props) {
        super(props)
        this.props = props

        this.inititalState = {
            currentAnnotationEvent: undefined,
            eventsHovered: [],
            form: undefined,
            showForm: false,
            showTooltip: false,
            Form: undefined,
            formsOpen: false,
            submitted: false,
            tooltip: {}
        }

        this.state = {
            ...this.inititalState,
            showTooltip: props.showTooltip
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        const { showTooltip, showForm, eventsHovered } = nextProps

        if (showTooltip !== this.props.showTooltip) {
            if (!showTooltip) {
                this.setState({
                    ...this.inititalState
                })
            } else {
                this.setState({
                    eventsHovered,
                    showForm,
                    showTooltip
                })
            }
        }
    }

    // TODO: CREATE A WELL DEFINIED EVENT TYPE TO REPLACE "Object"
    viewAnnotation = (e: Record<string, any>) => {
        this.setState({
            currentAnnotationEvent: e
        })
    }

    showAnnotationList = () => {
        this.setState({
            currentAnnotationEvent: undefined,
            showForm: false
        })
    }

    toggleForm = (Form, show = true) => {
        this.setState({
            showForm: show || !this.state.showForm,
            Form,
            submitted: false
        })
    }

    // TODO : IMPLEMENT formService TO BE RESPONSIBLE FOR FILLING FORM DATA
    onEditEvent = (event: Record<string, any>, formComponent) => {
        const isTemporal = this.props.mode === 'temporal'
        const form = {
            event,
            edit: true,
            message: event.message || '',
            color: formDefaultColor,
            fromDate: null,
            fromTime: null,
            toDate: null,
            toTime: null,
            fromNumeric: null,
            toNumeric: null
        }

        if (formColors.indexOf(event.__color) === -1) formColors.push(event.__color)

        if (isTemporal) {
            form.color = formColors.indexOf(event.__color)
            form.fromDate = DateService.getMoment(event.begin)
            form.fromTime = form.fromDate.format('HH:mm:ss')
            form.toDate = event.end ? DateService.getMoment(event.end) : null
            form.toTime = event.end && form.toDate ? form.toDate.format('HH:mm:ss') : null
        } else {
            form.fromNumeric = event.begin
            form.toNumeric = event.end
        }

        this.setState({
            form,
            Form: formComponent || DEFAULT_FORM,
            showForm: true,
            submitted: false
        })
    }

    onHideFormComponent = (
        data?: Record<string, any>,
        form?: Record<string, any>,
        initialFormState?: Record<string, any>,
        editing?: boolean
    ) => {
        const newState = {
            showForm: false,
            showTooltip: true,
            currentAnnotationEvent: data && data.uid && data,
            submitted: false,
            form: {
                ...initialFormState,
                saved: false
            },
            Form: undefined,
            formsOpen: false,
            eventsHovered: [],
            tooltip: this.state.tooltip
        }

        if (data && data.uid) {
            if (!editing) {
                newState.eventsHovered = [...this.props.eventsHovered, data]
                const tooltip = this.props.tooltip

                tooltip.numberOfNotes = tooltip ? ++tooltip.numberOfNotes : 0
                newState.tooltip = tooltip
            } else {
                // update events
                newState.eventsHovered = this.state.eventsHovered.map(e => (e.uid === data.uid ? data : e))
            }
            this.setState(newState)
        } else {
            this.hide()
        }
    }

    toggleFormList = () => {
        this.setState(s => ({ formsOpen: !s.formsOpen }))
    }

    renderAnnotations = () => {
        const { mode, adminUser, canEdit, currentUser, onDeleteEvent, dashboardId } = this.props
        const { showTooltip, currentAnnotationEvent, eventsHovered } = this.state
        const expanded = currentAnnotationEvent && showTooltip
        const showList = showTooltip && eventsHovered.length
        const isAuthor = currentAnnotationEvent ? +currentAnnotationEvent.authorId === +currentUser.id : false
        const Annotation = this.props.annotationComponent

        return (
            <div
                className={`timeline__notes-container ${
                    expanded && !showList ? 'timeline__notes-container--expanded' : ''
                }`}
            >
                {expanded ? (
                    <Annotation
                        mode={mode}
                        dashboardId={dashboardId}
                        onDelete={isAuthor || adminUser ? () => onDeleteEvent(currentAnnotationEvent) : null}
                        onEdit={isAuthor || canEdit ? this.onEditEvent : null}
                        expanded={true}
                        event={currentAnnotationEvent}
                    />
                ) : showList ? (
                    <div className="timeline__notes-content">
                        {' '}
                        {eventsHovered.map((e, i) => (
                            <Annotation
                                dashboardId={dashboardId}
                                mode={mode}
                                onClick={() => this.viewAnnotation(e)}
                                event={e}
                                key={`${e.timestamp}${i}`}
                            />
                        ))}
                    </div>
                ) : null}
            </div>
        )
    }

    renderForms = () => (
        <TimelineFormRegistry.Consumer>
            {forms => (
                <div className="timeline__notes-footer__forms-container">
                    {forms.map((Form: MessengerForm) => (
                        <div
                            onClick={() => this.toggleForm(Form, true)}
                            className="timeline__notes-footer__form"
                            key={Form.shortTitle}
                        >
                            {Form.title}
                        </div>
                    ))}

                    <div onClick={() => this.toggleForm(DEFAULT_FORM)} className="timeline__notes-footer__form">
                        {DEFAULT_FORM.title}
                    </div>
                </div>
            )}
        </TimelineFormRegistry.Consumer>
    )

    hide = () => {
        this.setState({
            showTooltip: false,
            showForm: false,
            formsOpen: false,
            eventsHovered: []
        })
        this.props.onHideTooltip()
    }

    renderFooter = () => {
        const { formsOpen } = this.state

        return (
            <div className="timeline__notes-footer">
                {formsOpen ? this.renderForms() : null}
                <div onClick={this.toggleFormList} className="timeline__notes-footer__button">
                    {formsOpen ? `${i18n('CANCEL')}` : `+ ${i18n('CREATE')}`}
                </div>
            </div>
        )
    }

    render() {
        // Note: props.eventsHovered and state.eventsHovered represent different things
        // first one is available as soon as the user hovers over the timeline, and lists any events
        // that match that instant.
        // the second one is initialized once the user clicks the timeline, and contains the annotations that
        // are currently being rendered.
        // Current code rely on the state.eventsHovered behavior so we copy props.eventsHovered to a new variable eventsHoveredInTimeline

        const {
            tooltip,
            canEdit,
            adminUser,
            mode,
            dashboardId,
            activeDashboardFilters,
            eventsHovered: eventsHoveredInTimeline
        } = this.props
        const { showForm, formsOpen, Form, currentAnnotationEvent, showTooltip, eventsHovered } = this.state
        const tooltipOpen = (showTooltip && (eventsHovered.length || currentAnnotationEvent)) || showForm

        const cls = cx({
            // eslint-disable-next-line @typescript-eslint/camelcase
            timeline__tooltip: true,
            'timeline__tooltip--open': tooltipOpen,
            'timeline__tooltip--forms': formsOpen
        })

        const TooltipRegistryConsumer = timelineService.tooltipComponentRegistry.Consumer

        return (
            <div ref={this.props.setTooltipRef} className={cls}>
                <div ref={this.props.setTooltipCrosshairRef} className="timeline__tooltip-crosshair" />
                {formsOpen && !Form ? <div onClick={this.toggleFormList} className="timeline__tooltip__layer" /> : null}
                <div className="timeline__tooltip-content">
                    <div className="timeline_notes-header">
                        {currentAnnotationEvent ? (
                            <div className="timeline__notes-back-container" onClick={this.showAnnotationList}>
                                <i className="fa fa-long-arrow-left" />
                                {i18n('BACK TO NOTES LIST')}
                            </div>
                        ) : showForm && formsOpen && Form ? (
                            <span>
                                <label className="timeline__tooltip-notes">{Form.title}</label>
                            </span>
                        ) : (
                            <TooltipRegistryConsumer>
                                {Components => {
                                    if (Components.length) {
                                        return Components.map((Comp, key) => (
                                            <Comp
                                                key={key}
                                                eventsHoveredInTimeline={eventsHoveredInTimeline}
                                                {...this.props}
                                                {...this.state}
                                                toggleForm={this.toggleForm}
                                                tooltip={tooltip} // props.tooltip is what is important to the components, but is shadowed by state.tooltip which has private use here
                                            />
                                        ))
                                    }

                                    return (
                                        <span>
                                            <label id="timeline__tooltip-value">
                                                {mode === 'temporal' ? (
                                                    <div>
                                                        <span>{tooltip.date} .</span> <span>{tooltip.time}</span>
                                                    </div>
                                                ) : (
                                                    <span>
                                                        {moment.isMoment(tooltip.value)
                                                            ? moment.valueOf()
                                                            : tooltip.value}
                                                    </span>
                                                )}
                                            </label>
                                            {tooltip.numberOfNotes && !showForm ? (
                                                <label className="timeline__tooltip-notes">
                                                    {tooltip.numberOfNotes > 9
                                                        ? tooltip.numberOfNotes
                                                        : `0${tooltip.numberOfNotes}`}{' '}
                                                    {tooltip.numberOfNotes > 1 ? i18n('NOTES') : i18n('NOTE') || ''}
                                                </label>
                                            ) : (canEdit || adminUser) && !showForm ? (
                                                <label onClick={this.toggleForm} className="timeline__tooltip-notes">
                                                    {i18n('Click to add note')}
                                                </label>
                                            ) : null}
                                        </span>
                                    )
                                }}
                            </TooltipRegistryConsumer>
                        )}
                    </div>

                    <div
                        className={`timeline__tooltip__context-container ${
                            showForm && (canEdit || adminUser) && !Form
                                ? 'timeline__tooltip__context-container--blank'
                                : ''
                        }`}
                    >
                        {showForm && (canEdit || adminUser) ? (
                            Form ? (
                                <Form.component
                                    mode={mode}
                                    event={
                                        currentAnnotationEvent || {
                                            begin: moment.isMoment(tooltip.value) ? +tooltip.value._d : tooltip.value
                                        }
                                    }
                                    onHide={this.onHideFormComponent}
                                    dashboardId={dashboardId}
                                    showActions={true}
                                    activeDashboardFilters={activeDashboardFilters}
                                />
                            ) : (
                                <div>
                                    <BlankState />
                                    {this.renderFooter()}
                                </div>
                            )
                        ) : (
                            this.renderAnnotations()
                        )}
                    </div>

                    {(canEdit || adminUser) &&
                    showTooltip &&
                    !currentAnnotationEvent &&
                    !showForm &&
                    eventsHovered.length
                        ? this.renderFooter()
                        : null}
                </div>
            </div>
        )
    }
}

const BlankState = () => {
    return <div className="live-annotation__blank-state">{i18n('Nothing found here.')}</div>
}
